(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["responsive-banner"] && !Shopify.designMode) return;
  try {
    
// Optional JavaScript for additional functionality
document.addEventListener('DOMContentLoaded', function() {
  // Add viewport meta tag for better mobile fullscreen support
  if (document.querySelector('.fullscreen-banner')) {
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      viewportMeta.name = 'viewport';
      document.head.appendChild(viewportMeta);
    }
    viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
  }

  const videos = document.querySelectorAll('.mobile-video-container video');
  
  // Ensure videos autoplay on mobile
  videos.forEach(video => {
    video.play().catch(error => {
      console.log('Autoplay was prevented. User interaction required.');
    });
    
    // Replay video when it ends
    video.addEventListener('ended', function() {
      video.play();
    });
  });
  
  // Additional handling for mobile browsers with changing viewport heights
  if (document.querySelector('.fullscreen-banner')) {
    function updateFullscreenHeight() {
      const viewportHeight = window.innerHeight;
      const fullscreenContainers = document.querySelectorAll('.fullscreen-banner .desktop-image-container, .fullscreen-banner .mobile-video-container, .fullscreen-banner .placeholder-container');
      
      fullscreenContainers.forEach(container => {
        container.style.height = viewportHeight + 'px';
      });
    }
    
    // Run on initial load
    updateFullscreenHeight();
    
    // Run on window resize
    window.addEventListener('resize', updateFullscreenHeight);
    
    // Run on mobile orientation change
    window.addEventListener('orientationchange', function() {
      // Small delay to let the orientation fully change
      setTimeout(updateFullscreenHeight, 100);
    });
    
    // Some mobile browsers also need scroll events
    window.addEventListener('scroll', updateFullscreenHeight, { passive: true });
  }
});

  } catch(e) { console.error(e); }
})();
})();
